<rds-form-field labelPosition="side-left">
  <rds-control-label>{{ label() }}</rds-control-label>
  <textarea #input class="expandable" rdsInput
            [formControl]="control()" [attr.data-testid]="dataTestId()"
            [attr.title]="tooltip()"
  ></textarea>
</rds-form-field>
